module.exports = global["accounting"] = require("-!./accounting.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/accounting/accounting.js-exposed
// module id = 2
// module chunks = 0 1